"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcEmployeeList = exports.WEmployeeModal = exports.UcEmployeeFieldset = exports.UcEmployeeCard = void 0;
const UcEmployeeCard_yaml_component_1 = __importDefault(require("./UcEmployeeCard.yaml?component"));
exports.UcEmployeeCard = UcEmployeeCard_yaml_component_1.default;
const UcEmployeeFieldset_yaml_component_1 = __importDefault(require("./UcEmployeeFieldset.yaml?component"));
exports.UcEmployeeFieldset = UcEmployeeFieldset_yaml_component_1.default;
const WEmployeeModal_yaml_component_1 = __importDefault(require("./WEmployeeModal.yaml?component"));
exports.WEmployeeModal = WEmployeeModal_yaml_component_1.default;
const UcEmployeeList_yaml_component_1 = __importDefault(require("./UcEmployeeList.yaml?component"));
exports.UcEmployeeList = UcEmployeeList_yaml_component_1.default;
